import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import type { Calculator } from "@/lib/calculators/types";

export default function CalculatorCard({ calculator }: { calculator: Calculator }) {
  const { slug, cardTitle, description, eyebrow, icon: Icon } = calculator;
  return (
    <Link
      href={`/calculators/${slug}`}
      prefetch={false}
      className="group relative flex h-full flex-col rounded-2xl border border-[#E7ECF6] bg-white p-6 transition-all duration-200 hover:border-crayoBlue/40 hover:shadow-[0_6px_24px_-8px_rgba(77,127,237,0.22)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-crayoBlue/40"
    >
      <div className="mb-4 flex items-start justify-between gap-3">
        <span className="flex size-10 items-center justify-center rounded-xl bg-crayoBlue/10 text-crayoBlue">
          <Icon className="size-5" strokeWidth={2} />
        </span>
        <ArrowUpRight
          className="size-4 text-[#8B93A7] transition-all duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-crayoBlue"
          strokeWidth={2}
        />
      </div>
      <span className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8B93A7]">
        {eyebrow}
      </span>
      <h3 className="mb-2 mt-1 text-[19px] font-semibold leading-[1.2] tracking-tight text-gray-900">
        {cardTitle}
      </h3>
      <p className="text-[13.5px] leading-[1.6] text-[#5C6678]">{description}</p>
    </Link>
  );
}
